// import main style dependency file
import "antd/dist/antd.min.css";
import "./i18n/index.tsx";
import "./index.css";

import * as React from "react";
import * as ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import Authenticator from "./Authenticator";
import ErrorFallback from "./components/ErrorFallback";
import GlobalStyle from "./globalStyles";
import { initializeSentry, SentryErrorBoundary } from "./services/sentry";
import theme from "./theme";

// Initialize Sentry as early as possible. DSN is a public Sentry construct so
// it's safe to bundle into the client; loaded from .env via Vite's VITE_*
// prefix convention.
initializeSentry((import.meta.env.VITE_SENTRY_DSN as string | undefined) ?? "");

const App = () => {
  return (
    <SentryErrorBoundary fallback={props => <ErrorFallback {...props} />}>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <Authenticator />
          <GlobalStyle />
        </BrowserRouter>
      </ThemeProvider>
    </SentryErrorBoundary>
  );
};

const rootEl = document.getElementById("root");

ReactDOM.render(<App />, rootEl);

// CRA-era webpack HMR (`module.hot`) removed — Vite handles React HMR
// automatically via @vitejs/plugin-react. No manual hook needed.
